import {
  SET_USER_TRACK_DETAILS
} from 'actions/visits'

export const initialState = []

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_TRACK_DETAILS: {
      const updated = action.details
      const existing = state.find(d => d.userId === updated.userId)
      const newDetails = existing ? { ...existing, ...updated } : { ...updated }
      return [...state.filter(d => d.userId !== updated.userId), newDetails]
    }
  }
  return state
}
